import React from 'react';

import { ManagePayoutOrders } from 'features/payout-orders';

export const OperatorPayoutOrdersPage: React.FC = () => <ManagePayoutOrders />;
